import { faAtom, faDna, faFaceThinking, faHeadSideBrain } from '@fortawesome/pro-regular-svg-icons';

// Kept free of UI imports: the typed med-school core reads these, and anything that reaches MUI pulls its
// declarations into a project whose strict settings they do not pass.

export const MCAT_SCORE_SECTION_MIN = 118;
export const MCAT_SCORE_SECTION_MAX = 132;

export const MCAT_SUBJECTS = {
  cpf: {
    key: 'cpf',
    name: 'Chemical & Physical Foundations',
    short_name: 'CPF',
    regex: /chemical (&|and) physical foundations( of biological systems)?/i,
    color: 'skyblue',
    icon: faAtom,
  },
  cars: {
    key: 'cars',
    name: 'Critical Analysis & Reasoning',
    short_name: 'CARS',
    regex: /critical analysis (&|and) reasoning( skills)?/i,
    color: 'yellow',
    icon: faFaceThinking,
  },
  bbf: {
    key: 'bbf',
    name: 'Biology & Biochemistry Foundations',
    short_name: 'BBF',
    regex: /biolog(y|ical) (&|and) biochem(istry|ical) foundations( of living systems)?/i,
    color: 'secondary',
    icon: faDna,
  },
  psf: {
    key: 'psf',
    name: 'Psychology & Sociology Foundations',
    short_name: 'PSF',
    regex: /psycholog(y|ical)(,| &| and) soci(al|ological|ology)(,? and biolog(y|ical))? foundations( of behaviou?r)?/i,
    color: 'green',
    icon: faHeadSideBrain,
  },
};

export const MCAT_SECTION_KEYS = /** @type {const} */ (['cpf', 'cars', 'bbf', 'psf']);

export const MCAT_SUBJECT_LIST = MCAT_SECTION_KEYS.map(k => MCAT_SUBJECTS[k]);
